export function InviteAcceptPage() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="max-w-md rounded-2xl bg-white p-8 text-center shadow-sm">
        <div className="text-2xl font-bold tracking-tight">
          <span className="text-blue-400">Repair</span>
          <span className="text-gray-900">iz</span>
          <span className="text-primary"> Invite</span>
        </div>
        <p className="mt-3 text-sm text-slate-500">Invite acceptance will be wired in a later pass.</p>
      </div>
    </div>
  );
}
